/**
 * サーバーエラー例外.
 */
export default class ServerErrorException extends Error {}
